import moment from 'moment-timezone'

function dateFormatter(date, tz) {
  if (!date) {
    return ''
  }
  return `${moment(date).format('lll')}`
}

export {
  dateFormatter
}